pez.module('carousel', function($, $el) {
    var $win = $(window);
    var slideIndex = -1;
    var $slider = $el.find('.slider');
    var $slides = $el.find('.slide');
    var $divots = $el.find('.slide-controls').children();
    var interval = null;
    var autoscrollSpeedMS = 10000;
    var maxH = 0;
    var heightBuffer = 40;

    function resize() {
        $slider.css('min-height', 0);
        $slides.each(function() {
            var h = $(this).find('.slide-content').outerHeight();
            maxH = Math.max(h, maxH);
        });
        $slider.css('min-height', maxH + heightBuffer);
    }

    function move(i, manual) {
        if(manual) {
            resetAutoScroll();
        }
        if(i == slideIndex) return false;

        if(i < 0) {
            i = $slides.length - 1;
        } else if(i > $slides.length - 1) {
            i = 0;
        }
        slideIndex = i;
        var $slide = $($slides.get(slideIndex));
        var $divot = $($divots.get(slideIndex));

        $slides.hide();
        $slide.fadeIn(autoscrollSpeedMS * .1);

        $divots.removeClass('active');
        $divot.addClass('active');
        return false;
    }

    function next() {
        return move(slideIndex + 1, true);
    }

    function prev() {
        return move(slideIndex - 1, true);
    }

    function $moveAtIndex() {
        return move($(this).index(), true);
    }

    function resetAutoScroll() {
        if(!interval) return; //don't start it up
        stopAutoScroll();
        startAutoScroll();
    }

    function checkForScroll() {
        var ey = $el.offset().top + $el.height();
        var st = $('body').scrollTop();
        var wy = $('body').scrollTop() + $win.height();
        if(st > ey || ey > wy) {
            stopAutoScroll();
        } else if(wy > ey && !interval) {
            startAutoScroll();
        }
        return false;
    }

    function startAutoScroll() {
        if(interval) return;
        interval = setInterval(function() {
            move(slideIndex + 1, false);
        }, autoscrollSpeedMS);
        return false;
    }

    function stopAutoScroll() {
        if(!interval) return;
        clearInterval(interval);
        interval = null;
        return false;
    }

    function hammerMe() {
        var hammertime = new Hammer($el.get(0));
        hammertime.on('panend', function ( e ) {
            var xOffset = e.deltaX;
            var direction, threshold;
            direction = xOffset < 0 ? 'left' : 'right';
            threshold = Math.abs(xOffset) > (window.innerWidth / 8);

            if (direction === 'right' && threshold) {
                prev();
            } else if (direction === 'left' && threshold) {
                next();
            }
        });
    }

    move(0);
    $el.find('.slide-arrow.left').click(prev);
    $el.find('.slide-arrow.right').click(next);
    $el.hover(stopAutoScroll, startAutoScroll);
    $divots.click($moveAtIndex);
    $win.bind('scroll', checkForScroll);
    checkForScroll();
    hammerMe();
    resize();
    $win.resize(resize);

    /*
    // Principles
    // Slide Controls
    var container, controls, activeSlideNumber, numberOfPrinciples;
    container = $('#slider');
    controls = $('.slide-control');
    activeSlideNumber = 0;
    numberOfPrinciples = controls.length - 1;

    // Incorporate Hammer.js
    var $slider = $('.slider-container');
    if($slider.length) {
        var hammertime = new Hammer( $slider.get(0) );
        hammertime.on('panend', function ( e ) {
          var xOffset = e.deltaX;
          var direction, threshold;
          direction = xOffset < 0 ? 'left' : 'right';
          threshold = Math.abs(xOffset) > (window.innerWidth / 8);

          if ( direction === 'left' && threshold && activeSlideNumber < numberOfPrinciples ) {
            activeSlideNumber++;
          } else if ( direction === 'left' && threshold && activeSlideNumber === numberOfPrinciples) {
            activeSlideNumber = 0;
          } else if ( direction === 'right' && threshold && activeSlideNumber > 0 ) {
            activeSlideNumber--;
          } else if ( direction === 'right' && threshold && activeSlideNumber === 0 ) {
            activeSlideNumber = numberOfPrinciples;
          }

          resetSliderPosition()
        })
    }

    // Cycle principles
    var foldPosition, principlesPosition, intervalIsNotSet;
    principlesPosition = container.offset().top;
    intervalIsNotSet = true;

    $(window).on('scroll touchmove', function( e ) {
      foldPosition = $('body').scrollTop() + $(window).height();

      if ( foldPosition > principlesPosition && intervalIsNotSet ) {
        console.log('broke fold threshold');
        intervalIsNotSet = false;
        var interval = window.setInterval(function() {
          if ( TweenMax.isTweening( container ) ) return;

          if ( activeSlideNumber < numberOfPrinciples ) {
            activeSlideNumber++
          } else {
            activeSlideNumber = 0;
            // window.clearInterval(interval);
          }

          resetSliderPosition();
        }, 7000)
      }
    })
    */
});
